module.exports = __webpack_public_path__ + "img/3.144fe480.jpg";